<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.showPackage") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #ef3405">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Name Input -->
          <div class="preview-container text-center my-3">
            <img
              v-if="data.image.path"
              col="12"
              :src="data.image.path"
              :alt="$t('PLACEHOLDERS.packageImage')"
            />
          </div>

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.name_ar')"
            v-model.trim="data.name_ar"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.name_fr')"
            v-model.trim="data.name_fr"
            disabled
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.desc_ar')"
            v-model.trim="data.desc_ar"
            disabled
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.desc_fr')"
            v-model.trim="data.desc_fr"
            disabled
          />
          <!-- End:: Name Input -->

          <!-- Start:: perioud Input -->
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.package_duration')"
            v-model.trim="data.perioud"
            disabled
          />
          <!-- End:: perioud Input -->

          <!-- Start:: price Input -->
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.package_price')"
            v-model.trim="data.price"
            disabled
          />
          <!-- Start:: Input -->

          <!-- Start:: price Input -->
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.count_pay')"
            v-model.trim="data.count_pay"
            disabled
          />
          <!-- Start:: Input -->

          <!-- Start:: Input -->
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.count_users')"
            v-model.trim="data.count_users"
            disabled
          />
          <!-- Start:: Input -->
          <!-- <div class="input_wrapper switch_wrapper my-5 col-6">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
              disabled
            ></v-switch>
          </div> -->
          <!-- End:: Deactivate Switch Input -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ShowPackage",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        },
        name_ar: null,
        name_fr: null,
        desc_ar: null,
        desc_fr: null,
        perioud: null,
        price: null,
        count_users: null,
        count_pay: null,
      },
      capacities: [],

      // End:: Data Collection To Send
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  methods: {
    // start show data
    async showPackage() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `packages/${this.$route.params?.id}`,
        });
        this.data.image.path = res.data.data.Package.image;
        this.data.name_ar = res.data.data.Package.name_ar;
        this.data.name_fr = res.data.data.Package.name_fr;
        this.data.desc_ar = res.data.data.Package.description_ar;
        this.data.desc_fr = res.data.data.Package.description_fr;
        this.data.perioud = res.data.data.Package.days;
        this.data.price = res.data.data.Package.price;
        this.data.count_pay = res.data.data.Package.count_pay;
        this.data.count_users = res.data.data.Package.count_users;
      } catch (error) {
        this.loading = false;
        console.log(error?.response?.data?.message);
      }
    },
    // end show data
  },

  created() {
    this.showPackage();
  },
};
</script>
